import React from 'react';
import { Headline, moneyUtils } from '@sato/components';
import { observer } from 'mobx-react-lite';
import { twMerge } from 'tailwind-merge';

import { coldWaterColor } from '@components/Charts/chartTheme';
import { warmWaterColor } from '@components/Charts/waterUsage.theme';
import { UsagePrices } from '@models/waterUsage.types';
import { localizationStore } from '@stores/localization';

import { WaterListItem } from './WaterListItem';

export const WaterUsagePrices = observer(
  ({ coldWater, warmWater }: UsagePrices) => {
    const formattedWarmWaterPrice = warmWater
      ? moneyUtils.formatMoney(
          { currency: 'EUR', value: warmWater },
          localizationStore.language
        )
      : undefined;

    const formattedColdWaterPrice = coldWater
      ? moneyUtils.formatMoney(
          { currency: 'EUR', value: coldWater },
          localizationStore.language
        )
      : undefined;

    return (
      <div className={twMerge('flex flex-col gap-3 md:items-center')}>
        <Headline
          level={3}
          className="!font-header !text-5 uppercase lg:text-center"
        >
          {localizationStore.getTranslation('waterUsage.waterPrice')}
        </Headline>

        <div className="flex flex-col justify-center gap-x-5 gap-y-3 md:flex-row">
          {formattedColdWaterPrice && (
            <WaterListItem
              color={coldWaterColor}
              title={localizationStore.getTranslation(
                'waterUsageColdWaterLabel'
              )}
            >
              {formattedColdWaterPrice}/m³
            </WaterListItem>
          )}

          {formattedWarmWaterPrice && (
            <WaterListItem
              color={warmWaterColor}
              title={localizationStore.getTranslation(
                'waterUsageWarmWaterLabel'
              )}
            >
              {formattedWarmWaterPrice}/m³
            </WaterListItem>
          )}
        </div>
      </div>
    );
  }
);
